"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewebPayApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class NewebPayApi extends runtime.BaseAPI {
    /**
     * 建立信用卡付款請求（加密 TradeInfo）  支援同一訂單編號重複付款（如果未成功付款）
     */
    newebPayCreateCreditCardPaymentPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/CreateCreditCardPayment`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.NewebPayCreditCardRequestToJSON)(requestParameters['newebPayCreditCardRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 建立信用卡付款請求（加密 TradeInfo）  支援同一訂單編號重複付款（如果未成功付款）
     */
    newebPayCreateCreditCardPaymentPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.newebPayCreateCreditCardPaymentPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 解密藍新金流回傳資料（供前端 PaymentReturn 頁面使用）
     */
    newebPayDecryptCallbackPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/DecryptCallback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.NewebPayDecryptRequestToJSON)(requestParameters['newebPayDecryptRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 解密藍新金流回傳資料（供前端 PaymentReturn 頁面使用）
     */
    newebPayDecryptCallbackPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.newebPayDecryptCallbackPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    newebPayGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    newebPayGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.newebPayGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢付款請求詳細資料（供除錯使用）
     */
    newebPayGetPaymentDetailGetPaymentDetailPaymentResultIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['paymentResultId'] == null) {
                throw new runtime.RequiredError('paymentResultId', 'Required parameter "paymentResultId" was null or undefined when calling newebPayGetPaymentDetailGetPaymentDetailPaymentResultIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/GetPaymentDetail/GetPaymentDetail/{paymentResultId}`.replace(`{${"paymentResultId"}}`, encodeURIComponent(String(requestParameters['paymentResultId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢付款請求詳細資料（供除錯使用）
     */
    newebPayGetPaymentDetailGetPaymentDetailPaymentResultIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.newebPayGetPaymentDetailGetPaymentDetailPaymentResultIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 藍新金流回傳處理（解密 TradeInfo）
     */
    newebPayHandleCallbackPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['status'] != null) {
                formParams.append('Status', requestParameters['status']);
            }
            if (requestParameters['merchantID'] != null) {
                formParams.append('MerchantID', requestParameters['merchantID']);
            }
            if (requestParameters['tradeInfo'] != null) {
                formParams.append('TradeInfo', requestParameters['tradeInfo']);
            }
            if (requestParameters['tradeSha'] != null) {
                formParams.append('TradeSha', requestParameters['tradeSha']);
            }
            if (requestParameters['version'] != null) {
                formParams.append('Version', requestParameters['version']);
            }
            if (requestParameters['encryptType'] != null) {
                formParams.append('EncryptType', requestParameters['encryptType']);
            }
            const response = yield this.request({
                path: `/NewebPay/HandleCallback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 藍新金流回傳處理（解密 TradeInfo）
     */
    newebPayHandleCallbackPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.newebPayHandleCallbackPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢訂單支付狀態（呼叫藍新金流查詢 API）  用於前端 PaymentReturn 頁面檢查訂單狀態
     */
    newebPayQueryOrderStatusPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/QueryOrderStatus`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.NewebPayQueryRequestToJSON)(requestParameters['newebPayQueryRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢訂單支付狀態（呼叫藍新金流查詢 API）  用於前端 PaymentReturn 頁面檢查訂單狀態
     */
    newebPayQueryOrderStatusPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.newebPayQueryOrderStatusPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 向藍新金流查詢單筆交易狀態
     */
    newebPayQuerySingleTradeFromNewebPayPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/NewebPay/QuerySingleTradeFromNewebPay`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.NewebPaySingleTradeQueryRequestToJSON)(requestParameters['newebPaySingleTradeQueryRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 向藍新金流查詢單筆交易狀態
     */
    newebPayQuerySingleTradeFromNewebPayPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.newebPayQuerySingleTradeFromNewebPayPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 藍新金流付款完成後瀏覽器跳轉端點（ReturnURL）  只負責把使用者導回前端，不做任何 DB 寫入
     */
    newebPayReturnPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['status'] != null) {
                formParams.append('Status', requestParameters['status']);
            }
            if (requestParameters['merchantID'] != null) {
                formParams.append('MerchantID', requestParameters['merchantID']);
            }
            if (requestParameters['tradeInfo'] != null) {
                formParams.append('TradeInfo', requestParameters['tradeInfo']);
            }
            if (requestParameters['tradeSha'] != null) {
                formParams.append('TradeSha', requestParameters['tradeSha']);
            }
            if (requestParameters['version'] != null) {
                formParams.append('Version', requestParameters['version']);
            }
            if (requestParameters['encryptType'] != null) {
                formParams.append('EncryptType', requestParameters['encryptType']);
            }
            const response = yield this.request({
                path: `/NewebPay/Return`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 藍新金流付款完成後瀏覽器跳轉端點（ReturnURL）  只負責把使用者導回前端，不做任何 DB 寫入
     */
    newebPayReturnPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.newebPayReturnPostRaw(requestParameters, initOverrides);
        });
    }
}
exports.NewebPayApi = NewebPayApi;
